<template>
  <div class="pl-2">
    <CModal
      color="primary"
      :show.sync="isShowModal"
      size="lg"
      :closeOnBackdrop="false"
    >
      <template #header>
        <h5>Preview Job</h5>
        <button
          aria-label="Close"
          name="preview-job-close-btn"
          class="close"
          @click="onCancelPreview()"
        >
          x
        </button>
      </template>
      <JobPreview
        :jobDetails="getSelectedJobBenefitsAndAdvertDesc"
      ></JobPreview>
      <template #footer>
        <div>
          <CButton
            color="secondary"
            name="preview-job-cancel-btn"
            @click="onCancelPreview()"
            >Close</CButton
          >
        </div>
      </template>
    </CModal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import JobPreview from "@/components/JobDetailPreview/JobDetailPreview.vue";

export default {
  name: "jobCardPreviewModal",
  props: ["isShowPopup", "onCancelPreview"],
  components: {
    JobPreview,
  },
  data() {
    return {
      isShow: this.isShowPopup,
    };
  },
  watch: {
    isShowPopup(newVal) {
      this.isShow = newVal;
    },
  },
  computed: {
    ...mapGetters(["getSelectedJobBenefitsAndAdvertDesc"]),
    isShowModal: {
      get() {
        return this.isShow;
      },
      set(isShowPopup) {
        this.isShow = isShowPopup;
      },
    },
  },
};
</script>
